import React from "react"
import Text from "components/common/Text"
import Space from "components/common/Space"
import { useTheme } from "styled-components"

const H2 = props => {
  const theme = useTheme()
  return (
    <Space padding="2rem 0px 0.5rem 0px">
      <Text
        size="large"
        weight="bold"
        lineHeight="small"
        color={theme.colors.accent.primary[500]}
        {...props}
      />
    </Space>
  )
}

export default H2
